import { motion } from "framer-motion";
import { ROLES, EDUCATION } from "@/data/content";
import { Reveal } from "@/components/bits/Reveal";
import { Tape, HandNote, Sticker } from "@/components/bits/Sticker";

const List = ({ title, items, color, testId }) => (
  <div className="relative bg-white border-[1.5px] border-[var(--ink)] hard-shadow p-6 md:p-8" data-testid={testId}>
    <Tape rotate={-4} className="-top-3 left-8" color={color} />
    <div className="flex items-center justify-between mb-6">
      <h3 className="pixel-title text-3xl md:text-4xl">{title}</h3>
      <span className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-[var(--ink-60)]">{items.length} credits</span>
    </div>
    <ul className="divide-y divide-dashed divide-[var(--ink-30)]">
      {items.map(([role, where], i) => (
        <motion.li
          key={role + where}
          className="grid grid-cols-[1.6rem_1fr] sm:grid-cols-[1.6rem_1fr_1fr] gap-x-4 py-3 items-baseline group"
          initial={{ opacity: 0, x: -12 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.03, duration: 0.5 }}
        >
          <span className="font-mono text-[0.62rem] text-[var(--ink-30)]">{String(i + 1).padStart(2, "0")}</span>
          <span className="font-body font-semibold text-sm md:text-[0.95rem] group-hover:text-[var(--blue)] transition-colors">{role}</span>
          <span className="font-hand text-lg text-[var(--ink-60)] col-start-2 sm:col-start-3 leading-tight">{where}</span>
        </motion.li>
      ))}
    </ul>
  </div>
);

export const Roles = () => (
  <section className="relative max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-32" data-testid="roles-section">
    <Reveal className="flex flex-col md:flex-row md:items-end gap-3 md:gap-8 mb-14">
      <h2 className="pixel-title text-5xl sm:text-6xl md:text-8xl">Credit Roll</h2>
      <HandNote className="text-2xl md:text-3xl -rotate-2 md:mb-3">every hat in the cupboard, listed</HandNote>
    </Reveal>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
      <List title="Production & Direction" items={ROLES.production} color="" testId="roles-production" />
      <div className="flex flex-col gap-10">
        <List title="Art Direction" items={ROLES.art} color="pink" testId="roles-art" />
        <Reveal className="relative bg-[var(--green)] border-[1.5px] border-[var(--ink)] hard-shadow p-6 md:p-8" data-testid="education-card">
          <Tape rotate={5} className="-top-3 right-8" color="blue" />
          <h3 className="pixel-title text-3xl md:text-4xl mb-5">Film school</h3>
          {EDUCATION.map(([deg, school, yrs]) => (
            <div key={deg} className="py-3 border-t border-dashed border-[var(--ink-30)] first:border-0 flex flex-wrap justify-between gap-2">
              <div>
                <div className="font-body font-semibold text-sm">{deg}</div>
                <div className="font-hand text-lg text-[var(--ink-60)] leading-tight">{school}</div>
              </div>
              <Sticker color="paper" rotate={-2} className="self-start">{yrs}</Sticker>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);
